import { useCallback, useState } from 'react';

export default function useLoadImage() {
    const [state, setState] = useState({ isFetching: true, isLoaded: false, error: null });

    const onLoad = useCallback(() => setState({ isFetching: false, isLoaded: true, error: null }), []);
    const onError = useCallback((error) => setState({ isFetching: false, isLoaded: false, error }), []);

    return {
        ...state,
        onLoad,
        onError,
    };
}
